import React, { useMemo } from 'react';

import { Flex } from '@chakra-ui/react';
import format from 'date-fns/format';
import { capitalize } from 'lodash';
import { RRule } from 'rrule';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const OneOnOneSetup = (params) => {
  const { isOneOnOneSetup } = params?.data?.employee?.value ?? '';
  const { recurrenceDetails, nextInstanceTS } = params?.data?.nextOneOnOne?.value ?? '';
  const oneOnoneSetupDate = nextInstanceTS ? format(new Date(nextInstanceTS * 1000), 'PPp') : 'NA';

  const recurrenceData = RRule.fromString(recurrenceDetails ?? '');
  const oneOnOneSetupDetails = recurrenceData.toText();

  const dayCapitalizedRRuleString = useMemo(() => {
    if (!oneOnOneSetupDetails) {
      return '';
    }
    const splittedRRule = oneOnOneSetupDetails.split(' ');
    const day = splittedRRule[splittedRRule.length - 1];
    const rest = splittedRRule.slice(0, splittedRRule.length - 1);
    return `${capitalize(rest.join(' '))} ${capitalize(day)}`;
  }, [oneOnOneSetupDetails]);

  return isOneOnOneSetup ? (
    <Flex flexDir="column" paddingTop={8}>
      <TextBodyMedium color="#666">{oneOnoneSetupDate}</TextBodyMedium>
      <TextLabel color="#666">{dayCapitalizedRRuleString ?? ''}</TextLabel>
    </Flex>
  ) : (
    <TextBodyMedium bold color="#C62C02" paddingTop={8}>
      1:1 Not Setup
    </TextBodyMedium>
  );
};

export default OneOnOneSetup;
